


import React, { useEffect, useState } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import { useNavigate } from 'react-router-dom';
import logo from "../../Assets/images/gif/danger.gif";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Api from '../../component/Api';


const Studetselection = () => {

    const [isFirstSubmit, setFirstSubmit] = useState(false);
    const [currentSemester, setCurrentSemester] = useState();
    const [isView, setIsview] = useState(false);
    const [minors, setMinors] = useState([]);
    const [aec, setAec] = useState([]);
    const [selectaec, setSelectaec] = useState(false);
    const [minors1, setMinors1] = useState(false);
    const [minors2, setMinors2] = useState(false);
    const [isvalue, setIsvalue] = useState(false);
    const pathway = parseInt(localStorage.getItem("pathway_id"), 10);
    const [result, setResult] = useState([]);
    const { http } = Api();

    const [steps, setSteps] = useState([]);
    const [selected, setSelected] = useState({});

    const [startdate, setStratdate] = useState(false);
    const [enddate, setEnddate] = useState(false);
    const [activeSemesters, setActiveSemesters] = useState([]);


    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleTab = (step) => {

        setCurrentSemester(step);



    };

    const handleNext = () => {
        if (currentSemester < steps.length) {
            setCurrentSemester(currentSemester + 1);

        }

    };

    const handlePreviousSemester = () => {
        if (currentSemester > 1) {
            setCurrentSemester(currentSemester - 1);

        }
    };


    const handlefirstsubmit = () => {

        setFirstSubmit(!isFirstSubmit);
    }

    const handleSuccess = () => {
        setFirstSubmit(!isFirstSubmit);
        if (minors1 && minors2 && selectaec) {
            
            


            http.post('Student/savestudentminors', {

                minor1: minors1,
                minor2: minors2,
                aec: selectaec

            })
                .then(Result => {
                    if (Result.data.status_code === "MSG1") {
                        setIsview(true);
                        setIsvalue(true);
                        toast.success(Result.data.message);

                    }
                    // console.log(Result);

                })
                .catch(error => {
                    if (error.response.data.status_code === "ERR2") {
                        toast.error(error.response.data.data.info)
                    }
                    else {
                        toast.error("Something went wrong:")
                    }

                });

        }
        else {
            toast.error("Selct all fileds")
        }
    }

    const handleCancel = () => {
        setFirstSubmit(!isFirstSubmit);
    }

    useEffect(() => {

        http.get(`Student/checkMinors`).then(Result => {

            if (Result.data.existing_minor.minor1) {
                setMinors1(Result.data.existing_minor.minor1);
            }
            if (Result.data.existing_minor.minor2) {
                setMinors2(Result.data.existing_minor.minor2);
            }
            if (Result.data.existing_minor.aec) {
                setSelectaec(Result.data.existing_minor.aec);
            }

            if (Result.data.existing_minor && Result.data.message.http_status === 409) {
                setIsvalue(true);
                setIsview(true);
            }
        }).catch(error => {
            // console.error("Error checking minors:", error);
        });

        http.get('/Student/getminors')
            .then(Result => {
                setMinors(Result.data)
            })
            .catch(error => {
                // console.log("error=", error);
                toast.error("Something went wrong:")
            });

        http.get('/Student/getAec')
            .then(Result => {
                setAec(Result.data)
                // console.log("re=", Result.data);
            })
            .catch(error => {
                // console.log("error=", error);
                toast.error("Something went wrong:")
            });


        http.get(`getStudentCourseEvents`, { params: { event_id: 2 } })
            .then(response => {
                // console.log("Full API response:", response.data);

                const activeSemesters = response.data[0].semester_id;
                setCurrentSemester(activeSemesters);
                setActiveSemesters(activeSemesters);
                setEnddate(response.data[0].end_date);
                setStratdate(response.data[0].start_date);


                if (!activeSemesters || typeof activeSemesters !== 'number' || activeSemesters <= 0) {
                    throw new Error(`Invalid activeSemesters value: ${activeSemesters}`);
                }

                const newSteps = Array.from({ length: activeSemesters }, (_, index) => ({
                    number: index + 1
                }));
                // console.log("New steps:", newSteps);



                setSteps(newSteps);


            }).catch(error => {
                // console.error("Error in getStudentCourseEvents:", error);
                toast.error("Something went wrong ");
            });


    }, [])


    useEffect(() => {

        if (isView) {
            setResult([]);
            http.get(`Student/getStudentcourses`, { params: { semester_id: currentSemester } }).then(Result => {
                setResult(Result.data)
               

            }).catch(error => {
                // console.log("error=", error);
                toast.error("Something went wrong:")
            });


        }

    }, [isView, currentSemester]);

    const minor2 = (e) => {

        const ctype = e.target.options[e.target.selectedIndex].getAttribute('coursetype');
        const id = e.target.value;

        setMinors2({
            id: id, ctype: ctype
        });
    }

    const aecchange = (e) => {

        const ctype = e.target.options[e.target.selectedIndex].getAttribute('coursetype');
        const id = e.target.value;

        setSelectaec({
            id: id, ctype: ctype
        });
    }


    const minor1 = (e) => {

        const ctype = e.target.options[e.target.selectedIndex].getAttribute('coursetype');
        const id = e.target.value;

        setMinors1({
            id: id, ctype: ctype
        });
    }
    // const cancelForm = () => {
    //     navigate("/admin/course");
    // };

    const handleSelectChange = (option, selectedId, cousregid) => {
        setSelected(prevSelected => {

            const updatedGroup = prevSelected[cousregid] || [];
            const existingIndex = updatedGroup.findIndex(item => item.course_id === selectedId || item.name === option);

            if (existingIndex !== -1) {
                // Update existing entry

                updatedGroup[existingIndex] = { course_id: selectedId, name: option };
            } else {
                // Add new entry
                updatedGroup.push({ course_id: selectedId, name: option });
            }

            return {
                ...prevSelected,
                [cousregid]: updatedGroup
            };
        });


    };

    const handleSubmit = () => {

        // console.log(selected);
    }

    return (
        <StudentTemplate>
            <ToastContainer />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12" >
                        <div className="card">
                            <div className="card-header">
                                <div className="py-3 st-hed-pb d-flex justify-content-between align-items-center">
                                    <h5>Student Course Selection</h5>
                                </div>
                            </div>
                            <div className="card-body pdg">
                                <div className="table-responsive">
                                    <div className="card-body">
                                        <div className="well rounded shadow" style={{ color: 'black' }}>
                                            <div className="custom-form-input">

                                                <div className="row">
                                                    <div className="col">
                                                        {pathway === 1 && (
                                                            <div className="row">
                                                                <label className="col-sm-5">Minor 1<span className="errorclr">*</span></label>
                                                                <div className="col-sm-7">
                                                                    <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" disabled={isvalue} required onChange={minor1}>
                                                                        <option value={0} >Select..</option>
                                                                        {Array.isArray(minors) && minors && minors.map((minors) => (
                                                                            minors2 != minors.id && (
                                                                                <option value={minors.id} coursetype={minors.ctype} selected={minors.id == minors1 ? 'selected' : null} >{minors.minors}</option>
                                                                            )
                                                                        ))

                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(pathway === 1 || pathway === 2) && (
                                                            <div className="row">
                                                                <label className="col-sm-5">Minor 2<span className="errorclr">*</span></label>
                                                                <div className="col-sm-7">
                                                                    <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" disabled={isvalue} required onChange={minor2}>
                                                                        <option value={0} >Select..</option>
                                                                        {Array.isArray(minors) && minors && minors.map((minors) => (
                                                                            minors1 != minors.id && (
                                                                                <option value={minors.id} coursetype={minors.ctype} selected={minors.id == minors2 ? 'selected' : null}  >{minors.minors}</option>
                                                                            )
                                                                        ))

                                                                        }
                                                                    </select>

                                                                </div>

                                                            </div>
                                                        )}
                                                        <div className="row">
                                                            <label className="col-sm-5">AEC Other Language<span className="errorclr">*</span></label>
                                                            <div className="col-sm-7">
                                                                <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" required disabled={isvalue} onChange={aecchange}>
                                                                    <option value={0} >Select..</option>
                                                                    {Array.isArray(aec) && aec && aec.map((aecs) => (
                                                                        <option key={aecs.id} coursetype={aecs.ctype} value={aecs.id} selected={aecs.id == selectaec ? 'selected' : null}  >
                                                                            {aecs.discipline_name}
                                                                        </option>
                                                                    ))}




                                                                </select>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                {!isvalue && (
                                                    <div className="col-md-12 txt-aln">
                                                        <button className="btn btn-primary me-3" onClick={handlefirstsubmit} disabled={isvalue} >Submit</button>
                                                        {/* <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} /> */}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="modal-toggle-wrapper">
                                <ul className="modal-img">
                                    <li> <img src={logo} /></li>
                                </ul>
                                <h4 className="text-center pb-2">Warning  Irreversible Action?</h4>
                                <p className="text-center">You are about to submit your changes.Once submitted,this action cannot be undone.</p>
                                <p className="text-center">Are you sure you want to proceed?</p>
                                <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-danger mx-2" onClick={() => handleSuccess()}>Submit</button>
                                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isView && (
                <div className="container-fluid">
                    <div class="container">
                        <ul class="progress-steps">
                            {steps.map((step, index) => (
                                <li class={`step ${index < currentSemester - 1 ? 'completed' : ''} ${index === currentSemester - 1 ? 'active' : ''}`}
                                    key={index}
                                    onClick={() => handleTab(step.number)}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={`Semester ${index + 1}`}>
                                    <div class="step-content">
                                        <span class="step-circle">{index + 1}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="col-md-12">
                                    {steps.map((step) => {
                                        const isActiveStep = activeSemesters === step.number;
                                        const currentDate = new Date();
                                        const startDate = new Date(startdate);
                                        const endDate = new Date(enddate);
                                        const isWithinDateRange = currentDate >= startDate && currentDate <= endDate;
                                        const isSelectable = isActiveStep && isWithinDateRange;

                                        return (
                                            <div key={step.number} style={{ display: currentSemester === step.number ? 'block' : 'none' }}>
                                                <div className="card-header">
                                                    <div className="py-3 d-flex justify-content-between align-items-center">
                                                        <h5>{step.number} Semester</h5>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="well rounded shadow p-4" style={{ color: 'black' }}>
                                                        <div className="mb-3 row">
                                                            {Object.keys(result).map((option, index) => (
                                                                <div key={index} className="form-group row" style={{ marginBottom: '10px' }}>
                                                                    <label htmlFor={`select-${step.number}-${index}`} className="col-sm-2 col-form-label">{option}</label>
                                                                    <div className="col-sm-10">

                                                                        <select className="form-select"
                                                                            onChange={(e) => {
                                                                                const selectedOption = e.target.options[e.target.selectedIndex];
                                                                                handleSelectChange(option, selectedOption.value, selectedOption.getAttribute('data-course-group-id'));
                                                                            }}
                                                                            disabled={!isSelectable}
                                                                        >

                                                                            <option value="">Select an option</option>
                                                                            {Array.isArray(result[option]) ? (
                                                                                result[option].map((opt, optIndex) => (
                                                                                    <option key={optIndex} value={opt.id} data-course-group-id={opt.course_group_id}  >
                                                                                        {opt.course_name}
                                                                                    </option>
                                                                                ))
                                                                            ) : (
                                                                                <option>No options available</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-4 d-flex justify-content-center">
                                                    <button
                                                        className="btn me-2 px-3 py-2"
                                                        style={{
                                                            backgroundColor: '#f0f0f0',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            color: '#333',
                                                            fontWeight: 'bold'
                                                        }}
                                                        onClick={handlePreviousSemester}
                                                        disabled={currentSemester === 1}
                                                    >
                                                        « Back
                                                    </button>
                                                    {currentSemester === steps.length && isSelectable ? (
                                                        <button
                                                            className="btn ms-2 px-3 py-2"
                                                            style={{
                                                                backgroundColor: '#007bff',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                color: 'white',
                                                                fontWeight: 'bold'
                                                            }}
                                                            onClick={handleSubmit}
                                                        >
                                                            Submit
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn ms-2 px-3 py-2"
                                                            style={{
                                                                backgroundColor: '#4CAF50',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                color: 'white',
                                                                fontWeight: 'bold'
                                                            }}
                                                            onClick={handleNext}
                                                            disabled={currentSemester === steps.length}
                                                        >
                                                            Next »
                                                        </button>
                                                    )}
                                                </div>
                                                <br></br><br></br>
                                            </div>
                                        );
                                    })}

                                    <br></br><br></br>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            )}

        </StudentTemplate>
    );
};

export default Studetselection;